// extracted by mini-css-extract-plugin
module.exports = {"aplixErrorBoxRoot":"aplixErrorBoxRoot--857fb"};